/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ paid: NonNullable<unknown> }} Partner_Admin_Kpi_PaidInputs */



/**
* | output |
* | --- |
* | "{paid} on paid plans" |
*
* @param {Partner_Admin_Kpi_PaidInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_admin_kpi_paid = /** @type {((inputs: Partner_Admin_Kpi_PaidInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Admin_Kpi_PaidInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.paid} mit Bezahltarif`)
	return /** @type {LocalizedString} */ (`${i?.paid} on paid plans`)
});